import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  clearAuthObj,
  login,
  setAccInfo, 
  setLoginInfo,
  setToken,
} from "../../features/auth/authSlice";
import axiosInstance from "../../instance";
import toast from "react-hot-toast";
import ndovuHr from "../../assets/img/ndovuPayShield.png";
import { getSubdomain } from "../../utils";
import "./login.css";
import { clearDropObj } from "../../features/dropdown/dropdownSlice";
import { clearFolderObj } from "../../features/folder/folderSlice";
import { clearSaveObj } from "../../features/save/saveSlice";
import { clearStaffObj } from "../../features/staff-setting/staffSettingSlice";

function Login() {
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { authLoading, user } = useSelector((state) => state.auth);

  const onFinish = async (data) => {
    const res = await dispatch(login(data));
    if (res?.payload?.success) {
      toast.success(res?.payload?.messages?.message);
      if (res?.payload?.otpRequired) {
        await dispatch(setLoginInfo(res?.payload?.jsonData));
        await navigate("/login-otp");
      } else if (res?.payload?.orgSelectionRequired) {
        await dispatch(setAccInfo(res?.payload?.jsonData));
        await navigate("/select-organization");
      } else {
        await dispatch(setToken(res?.payload?.token));
        axiosInstance.defaults.headers.common["Authorization"] =
          await `${res?.payload?.token}`;
        await navigate("/dashboard-main");
      }
    } else {
      toast.error(res?.payload?.messages?.message ?? "Bad Credentials");
    }
  };

  const handleLanding = () => {
    window.location.href = "https://ndovuhr.com/home.action";
  };
  const [subdomain, setSubdomain] = useState("");

  async function clean() {
    await dispatch(clearAuthObj());
    await dispatch(clearDropObj());
    await dispatch(clearFolderObj());
    await dispatch(clearSaveObj());
    await dispatch(clearStaffObj());
  }

  useEffect(() => {
    clean();
  }, []);

  useEffect(() => {
    setSubdomain(getSubdomain());
  }, []);

  return (
    <div className="flex h-[100vh] w-full overflow-y-scroll">
      <div
        className={`w-[50%] h-screen lg:flex hidden justify-center items-center login-pic }`}
      ></div>
      <div className="bg-[#f4f5f7] lg:w-[50%] w-full flex flex-col justify-center items-center lg:px-[10%] px-3">
        <div className="image-container">
          <img
            loading="lazy"
            decoding="async"
            src={ndovuHr}
            alt="logo"
            className="w-[400px]  h-[250px] object-contain animated-image"
          />
        </div>
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          style={{
            maxWidth: "100%",
          }}
          className="w-full mt-1"
          form={form}
        >
          <Form.Item
            label="Email address"
            className="login-form-item"
            name="usrUsername"
            rules={[
              {
                required: true,
                message: "Please input your username",
              },
            ]}
          >
            <Input type="usrUsername" className="input-login" />
          </Form.Item>
          <Form.Item
            label="Password"
            className="login-form-item"
            name="usrEncryptedPassword"
            rules={[
              {
                required: true,
                message: "Please input your password",
              },
            ]}
          >
            <Input.Password className="input-login" type="password" />
          </Form.Item>

          <button
            disabled={authLoading}
            className={`cstm-btn ${
              subdomain == "synqafrica" || subdomain == "synqtel"
                ? "!bg-syncBtn"
                : "!bg-orange"
            }   mt-[3.25rem]`}
            type="submit"
          >
            {authLoading ? <Spin /> : "Login"}
          </button>

          <div className="w-full flex lg:flex-row flex-col justify-between lg:items-center items-start mt-[1.75rem]">
            <Link
              className={`${
                subdomain == "synqafrica" || subdomain == "synqtel"
                  ? "!text-syncBtn"
                  : "text-darkBlue"
              } forgot_text lg:px-0 px-0`}
              to="/forgot-password"
            >
              Forgot Password ?
            </Link>
            <span>
              Dont have an account?{" "}
              <span
                className="text-darkBlue cursor-pointer"
                onClick={() => navigate("/signup")}
              >
                Sign up
              </span>
            </span>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default Login;
